import type ColumnMappingProps from '@Features/data-management/types/ColumnMappingProps'

const aptProps: ColumnMappingProps[] = [
  {
    required: true,
    key: 'name',
    text: 'Name',
  },
  {
    key: 'productcode',
    text: 'Product Code',
  },
  {
    key: 'barcode',
    text: 'Barcode',
  },
  {
    required: true,
    key: 'brand',
    text: 'Brand',
  },
  {
    required: true,
    key: 'category',
    text: 'Category',
  },
  {
    key: 'tags',
    text: 'Tags',
  },
  {
    key: 'cost',
    text: 'Product Cost',
  },
  {
    key: 'additional_cost',
    text: 'Additional Cost',
  },
  {
    key: 'mineurl',
    text: 'Your Own URL',
  },
]

export default aptProps
